<template>
    <v-container fluid align-start ma-0 pa-2 class="container-height">
        <v-row no-gutters fill-height>
            <v-col cols="12">
                <i-card-vertical headerTitle="5.5 Not yet Warehousing" :useBtnList="[
                    'btnRetrieve', //Retrieve
                    'btnSaveExcel' //Save Excel
                ]" @btnRetrieve="doSearchMain()" @btnSaveExcel="onExporting()">
                    <template v-slot:body>
                        <v-layout column overflow-auto>                          
                            <v-row no-gutters>
                                <v-col cols="12" class="pa-0">
                                    <v-row no-gutters>
                                        <v-col cols="12" align="right"  class="d-flex justify-end" style="color: #0000ff; font-weight: bold;">(NOT Included V.A.T)</v-col>
                                    </v-row>
                                    <DxDataGrid id="epms5040" class="listBox02" :ref="epms5040Ref" :data-source="gridMainList"
                                        :remote-operations="false" :hover-state-enabled="true" :allow-column-resizing="true"
                                        :allow-column-reordering="true" :row-alternation-enabled="true" :show-borders="true"
                                        :width="grid.width" :show-row-lines="true" key-expr="id" :focused-row-enabled="true"
                                        :column-hiding-enabled="false" :selection="{ mode: 'none' }" :sorting="{ mode: 'none' }"
                                        @cellPrepared="cellPrepared" @exporting="onExporting">

                                        <DxExport :enabled="true" />

                                        <DxColumn data-field="rnum" caption="No" width="5%" data-type="string"
                                            :allow-editing="false" alignment="center" />

                                        <DxColumn data-field="whReqDte" caption="Request W/H Date" width="10%" data-type="string"
                                                :allow-editing="false" alignment="center" header-cell-template = 'reqDte'/>                                        
                                        <template #reqDte>
                                           <div>Request<br/>W/H Date</div>
                                        </template>                                       
                                        <DxColumn caption="Ship No" width="10%" data-type="string" :allow-editing="false"
                                            alignment="center">
                                            <DxColumn data-field="shipNo" caption="Por No" width="10%" data-type="string"
                                                :allow-editing="false" alignment="center" />
                                        </DxColumn>
                                        <DxColumn caption="Material Code" width="12%" data-type="string"
                                            :allow-editing="false" alignment="center">
                                            <DxColumn data-field="matlCd" caption="PO No" width="12%"
                                                data-type="string" alignment="center" :allow-editing="false" cell-template="porNoTemplate"/>
                                        </DxColumn>

                                         <template #porNoTemplate="{ data }" >
                                            <div>
                                                <div v-if="data.rowIndex % 2 != 0">
                                                    <v-btn small elevation="0" color="transparent" class="px-0 py-0 my-auto grd-btn" @click.stop="clickPO($event)">
                                                        {{ data.value }}
                                                    </v-btn>
                                                </div>
                                                <div v-else>
                                                    {{ data.value }}
                                                </div>                                                                                               
                                            </div>
                                            
                                        </template>          

                                        <DxColumn data-field="matlSpec" caption="Material Specification" width="20%"
                                            data-type="string" :allow-editing="false" alignment="left" />

                                        <DxColumn data-field="matlUnit" caption="Unit" width="5%" data-type="string"
                                            :allow-editing="false" alignment="center" />

                                        <DxColumn caption="P.O Qty" width="10%" data-type="string" :allow-editing="false"
                                            alignment="right">
                                            <DxColumn data-field="poQty" caption="P.O Amt" width="7%" data-type="number"
                                                format="#,###" alignment="right" :allow-editing="false" />
                                            <DxColumn data-field="poAmt" caption="P.O Qty2" width="10%" data-type="number"
                                                format="#,###" alignment="right" :allow-editing="false" />
                                        </DxColumn>

                                        <DxColumn caption="W/H Qty" width="10%" data-type="string" alignment="right"
                                            :allow-editing="false">
                                            <DxColumn data-field="whQty" caption="W/H Amt" width="7%" data-type="number"
                                                format="#,###" alignment="right" :allow-editing="false" cell-template="plDtTemplate"/>
                                            <DxColumn data-field="whAmt" caption="W/H Qty2" width="10%" data-type="number"
                                                format="#,###" alignment="right" :allow-editing="false" cell-template="plDtTemplate"/>
                                        </DxColumn>

                                        <DxColumn caption="Plan Qty" width="10%" data-type="string" alignment="right"
                                            :allow-editing="false">
                                            <DxColumn data-field="plQty" caption="Plan Amt" width="7%" data-type="number"
                                                format="#,###" alignment="right" :allow-editing="false" cell-template="plDtTemplate"/>
                                            <DxColumn data-field="plAmt" caption="Plan Qty2" width="10%"
                                                data-type="number" format="#,###" alignment="right"
                                                :allow-editing="false" cell-template="plDtTemplate"/>
                                        </DxColumn>

                                        <DxColumn caption="Remain Qty" width="10%" data-type="string" alignment="right"
                                            :allow-editing="false">
                                            <DxColumn data-field="rmQty" caption="Remain Amt" width="7%" data-type="number"
                                                format="#,###" alignment="right" :allow-editing="false" cell-template="rmDtTemplate"/>
                                            <DxColumn data-field="rmAmt" caption="Remain Qty2" width="10%"
                                                data-type="number" format="#,###" alignment="right"
                                                :allow-editing="false" cell-template="rmDtTemplate"/>
                                        </DxColumn>

                                         <template #rmDtTemplate="{ data }">
                                                <div style="color:red">{{ data.text }}</div>
                                            </template>

                                            <template #plDtTemplate="{ data }">
                                                    <div style="color:blue">{{ data.text }}</div>
                                                </template>

                                        <DxPaging :enabled="true" :page-size="16" />
                                        <DxSummary>
                                            <DxTotalItem column="rnum" summary-type="sum" display-format="Total"
                                                alignment="center" />
                                            <DxTotalItem column="poQty" summary-type="sum" :customize-text="formatQty" />
                                            <DxTotalItem column="poAmt" summary-type="sum" :customize-text="formatPrice" />
                                            <DxTotalItem column="whQty" summary-type="sum" :customize-text="formatQty" />
                                            <DxTotalItem column="whAmt" summary-type="sum" :customize-text="formatPrice" />
                                            <DxTotalItem column="plQty" summary-type="sum" :customize-text="formatQty" />
                                            <DxTotalItem column="plAmt" summary-type="sum"
                                                :customize-text="formatPrice" />
                                            <DxTotalItem column="rmQty" summary-type="sum" :customize-text="formatQty" />
                                            <DxTotalItem column="rmAmt" summary-type="sum" :customize-text="formatPrice" />
                                        </DxSummary>
                                    </DxDataGrid>
                                </v-col>
                            </v-row>
                        </v-layout>
                    </template>
                </i-card-vertical>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { DxDataGrid, DxColumn, DxSummary, DxTotalItem, DxExport } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import baseview from '@/components/base/baseview.vue' // 
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import { epms5040List } from '@/api/view/hip/5/epms5040.js'
import { getNumComma } from '@/utils/common.js'
import { Workbook } from 'exceljs'
import { saveAs } from 'file-saver-es'


export default {
    name: 'epms5040',
    mixins: [baseview, BaseDataGrid],
    components: {
        DxDataGrid,
        DxColumn,
        DxSummary,
        DxTotalItem,
        DxExport,
        ICardVertical,
    },
    data() {
        return {
            gridMainList: [],
            epms5040Ref: "epms5040Ref"          
        }
    },

    mounted() {
        this.gridMainInstance.option('defaultPaging', false)
    },
    computed: {
        gridMainInstance() {
            return this.GetDataGrid(this.epms5040Ref)
        },
    },

    methods: {
        async doSearchMain() {
            this.gridMainList = []
            this.openLoading('searching')
            let params = {
                makerCd: this.$store.state.user.makerCd,
                poNo: this.poNo
            }

            await epms5040List(params).then(res => {
                let list = []
                let cnt = 1;
                res.list.forEach(e => {
                    list.push(
                        {
                            id: cnt++, rnum: e.rnum, shipNo: e.shipNo, block: e.block, matlCd: e.matlCd, whReqDte: e.whReqDte,
                            matlSpec: e.matlSpec, matlUnit: e.matlUnit, poAmt: 0, poQty: e.poQty,
                            whQty: e.whQty, whAmt: 0, plQty: e.plQty, plAmt: 0, rmQty: e.rmQty, rmAmt: 0

                        },
                        {
                            id: cnt++, rnum: e.rnum, shipNo: e.porNo + '-' + e.porSeq, block: e.block, matlCd: e.poNo, whReqDte: e.whReqDte,
                            matlSpec: e.matlSpec, matlUnit: e.matlUnit, poAmt: e.poAmt, poQty: 0,
                            whQty: 0, whAmt: e.whAmt, plQty: 0, plAmt: e.plAmt, rmQty: 0, rmAmt: e.rmAmt
                        },
                    )
                });
                this.gridMainList = list

            }).finally(() => {
                //console.log(this.gridMainList);
                this.endLoading();
            })
        },
        formatPrice(data) {
            return getNumComma(data.value)
        },
        formatQty(data) {
            return "Qty: " + getNumComma(data.value)
        },
        onExporting(e) {
            if (e) {
                e.cancel = true
            }

            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet('Not Yet Warehousing')
            const headers = [
                'No', 'Request W/H Date', 'Ship No', 'POR No', 'Material Code', 'P.O No',
                'Material Specification', 'Unit', 'P.O Qty', 'P.O Amt', 'W/H Qty', 'W/H Amt',
                'Plan Qty', 'Plan Amt', 'Remain Qty', 'Remain Amt'
            ]
            const headerRow = worksheet.addRow(headers)
            const headerStyle = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'DFE3D5' } }
            const borderStyle = {
                top: { style: 'thin', color: { argb: 'BFBFBF' } },
                left: { style: 'thin', color: { argb: 'BFBFBF' } },
                bottom: { style: 'thin', color: { argb: 'BFBFBF' } },
                right: { style: 'thin', color: { argb: 'BFBFBF' } }
            }

            headerRow.eachCell((cell) => {
                cell.fill = headerStyle
                cell.border = borderStyle
                cell.alignment = { horizontal: 'center', vertical: 'middle' }
            })

            for (let index = 0; index < this.gridMainList.length; index += 2) {
                const material = this.gridMainList[index]
                const purchaseOrder = this.gridMainList[index + 1] || {}
                const row = worksheet.addRow([
                    material.rnum,
                    material.whReqDte,
                    material.shipNo,
                    purchaseOrder.shipNo,
                    material.matlCd,
                    purchaseOrder.matlCd,
                    material.matlSpec,
                    material.matlUnit,
                    material.poQty,
                    purchaseOrder.poAmt,
                    material.whQty,
                    purchaseOrder.whAmt,
                    material.plQty,
                    purchaseOrder.plAmt,
                    material.rmQty,
                    purchaseOrder.rmAmt
                ])

                row.eachCell((cell, columnNumber) => {
                    cell.border = borderStyle
                    cell.alignment = {
                        horizontal: columnNumber >= 9 ? 'right' : 'center',
                        vertical: 'middle'
                    }
                    if (columnNumber >= 9) {
                        cell.numFmt = '#,##0.###'
                    }
                })
                row.getCell(7).alignment = { horizontal: 'left', vertical: 'middle' }
            }

            worksheet.columns = [
                { width: 8 }, { width: 18 }, { width: 16 }, { width: 18 },
                { width: 18 }, { width: 18 }, { width: 34 }, { width: 10 },
                { width: 14 }, { width: 16 }, { width: 14 }, { width: 16 },
                { width: 14 }, { width: 16 }, { width: 14 }, { width: 16 }
            ]

            workbook.xlsx.writeBuffer().then((buffer) => {
                saveAs(
                    new Blob([buffer], { type: 'application/octet-stream' }),
                    'NotYetWarehousing.xlsx'
                )
            })
        },
        clickPO(e) {
            this.$router.push({ name: 'epms5030', params: { poNo: e.srcElement.innerText } });  
        },
        //cell merge
        cellPrepared(e) {
            if (e.rowType === 'header') {
                if (e.column.caption === 'P.O Amt') {
                    e.cellElement.setAttribute('colspan', 2)
                } else if (e.column.caption === 'P.O Qty2') {
                    e.cellElement.style.display = 'none'
                }
                if (e.column.caption === 'W/H Amt') {
                    e.cellElement.setAttribute('colspan', 2)
                    e.cellElement.style.color = '#0000CC'
                } else if (e.column.caption === 'W/H Qty2') {
                    e.cellElement.style.display = 'none'
                } else if (e.column.caption === 'W/H Qty') {
                    e.cellElement.style.color = '#0000CC'
                }
                if (e.column.caption === 'Plan Amt') {
                    e.cellElement.setAttribute('colspan', 2)
                    e.cellElement.style.color = '#0000CC'
                } else if (e.column.caption === 'Plan Qty2') {
                    e.cellElement.style.display = 'none'
                }

                if (e.column.caption === 'Plan Qty') {
                    e.cellElement.style.color = '#0000CC'
                }

                if (e.column.caption === 'Remain Amt') {
                    e.cellElement.setAttribute('colspan', 2)
                    e.cellElement.style.color = '#FF0000'
                } else if (e.column.caption === 'Remain Qty2') {
                    e.cellElement.style.display = 'none'
                } else if (e.column.caption === 'Remain Qty') {
                    e.cellElement.style.color = '#FF0000'
                }
            } else if (e.rowType === 'data') {

                if (e.column.caption === 'No' || e.column.name === 'whReqDte' || e.column.caption === 'Unit' || e.column.caption === 'Material Specification') {
                    if (e.value == e.component.cellValue(e.rowIndex + 1, e.column.dataField) && e.values[0] == e.component.cellValue(e.rowIndex + 1, 'rnum')) {
                        e.cellElement.setAttribute('rowspan', 2)
                    } else {
                        e.cellElement.style.display = 'none'
                    }

                }

                // console.log(e)
                if (Number(e.rowIndex) % 2 === 0) {
                    if (e.column.name === 'poQty') {
                        e.cellElement.setAttribute('colspan', 2)

                    } else if (e.column.name === 'poAmt') {
                        e.cellElement.style.display = 'none'
                    }
                    if (e.column.name === 'whQty') {
                        e.cellElement.setAttribute('colspan', 2)

                    } else if (e.column.name === 'whAmt') {
                        e.cellElement.style.display = 'none'

                    }
                    if (e.column.name === 'plQty') {
                        e.cellElement.setAttribute('colspan', 2)

                    } else if (e.column.name === 'plAmt') {
                        e.cellElement.style.display = 'none'

                    }
                    if (e.column.name === 'rmQty') {
                        e.cellElement.setAttribute('colspan', 2)

                    } else if (e.column.name === 'rmAmt') {
                        e.cellElement.style.display = 'none'

                    }
                } else if (Number(e.rowIndex) % 2 !== 0) {
                    if (e.column.name === 'poAmt') {
                        e.cellElement.setAttribute('colspan', 2)

                    } else if (e.column.name === 'poQty') {
                        e.cellElement.style.display = 'none'
                    }
                    if (e.column.name === 'whAmt') {
                        e.cellElement.setAttribute('colspan', 2)

                    } else if (e.column.name === 'whQty') {
                        e.cellElement.style.display = 'none'

                    }
                    if (e.column.name === 'plAmt') {
                        e.cellElement.setAttribute('colspan', 2)

                    } else if (e.column.name === 'plQty') {
                        e.cellElement.style.display = 'none'

                    }
                    if (e.column.name === 'rmAmt') {
                        e.cellElement.setAttribute('colspan', 2)

                    } else if (e.column.name === 'rmQty') {
                        e.cellElement.style.display = 'none'

                    }
                }

            } else if (e.rowType === 'totalFooter') {
                    e.cellElement.style.fontSize = '11px'
                if (e.column.name === 'rnum' || e.column.name === 'poAmt' || e.column.name === 'whAmt' || e.column.name === 'plAmt' || e.column.name === 'rmAmt') {
                    e.cellElement.style.borderRight = '1px solid gray'
                }
                if (e.columnIndex == '0') {
                    e.cellElement.setAttribute('colspan', 6)
                } else if (e.columnIndex > '0' && e.columnIndex <= '5') {
                    e.cellElement.style.display = 'none'
                }
            }
        }

    }
}
</script>

<style scoped>
</style>